import React from 'react'
import { Navbar,Nav,NavDropdown,Form,FormControl,Button } from 'react-bootstrap'

const year = new Date().getFullYear()
class IYFAOFooter extends React.Component{
    constructor(props){
        super(props);
        this.state = {  
            copyright : {
                "en":{
                    "tagline":"Copyright @ "+year+"    All Rights Reserved.",
                },
                "zh":{
                    "tagline":"海克斯國際有限公司 @ "+year+"    版權所有",
                },
                "cn":{
                    "tagline":"海克斯国际有限公司 @ "+year+"    版权所有",
                },
            }
        };
    
        this.openlink = this.openlink.bind(this)
      }
    
      openlink(link){
        window.open(link)
      }
    render(){
        return(
            <div className="footer">
                <div className="footer-img-wrapper">
                    <div className="social-icons">
                        <a href="https://www.facebook.com/profile.php?id=100090897736064&mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer">
                            <img src="../../assets/fb48.png" alt="Facebook" />
                        </a>
                        <a href="https://www.instagram.com/icmtcompetition/?igsh=MTI2NnU1ZTk4dmQ4cA%3D%3D#" target="_blank" rel="noopener noreferrer">
                            <img src="../../assets/ig48.png" alt="Instagram" />
                        </a>
                        <a href="https://www.youtube.com/@ICMTCompetition" target="_blank" rel="noopener noreferrer">
                            <img src="../../assets/yt48.png" alt="YouTube" />
                        </a>
                    </div>

                    <div className="partner-logos">
                        <img src={"/assets/footerlogos/eaosa.PNG"} alt={"EAOSA"} height={"65px"} className={"footer-bottomlogo"} />
                        <img src={"/assets/footerlogos/worldmusic-asso-logo.PNG"} alt={"MA"} height={"65px"} className={"footer-bottomlogo"} />
                        <img src={"/assets/footerlogos/scholar-exchange-logo.PNG"} alt={"SEL"} height={"65px"} className={"footer-bottomlogo"} />
                        <img src={"/assets/footerlogos/rising-leader-logo.PNG"} alt={"RLS"} height={"65px"} className={"footer-bottomlogo"} />
                        <a href="https://ytmagasin.com/" target="_blank" rel="noopener noreferrer">
                            <img src="../../assets/footerlogos/euroasia-shop-logo.PNG" height={"65px"} alt="EA Mastery Shop" className={"footer-bottomlogo"} />
                        </a>
                        <img src={"/assets/footerlogos/yt_logo.PNG"} alt={"YT"} height={"65px"} className={"footer-bottomlogo"} />
                    </div>
                </div>

                <div className="footer-text-center">
                    <p style={{fontFamily:"Courgette"}}>{this.state.copyright[this.props.lang]["tagline"]}</p>
                </div>
            </div>
        )  
    }
}

export default IYFAOFooter;